import React, { useEffect, useState } from "react";

import { Divider, Icon } from "semantic-ui-react";

import EmailLogin from "react-lib/apps/IsHealth/Common/EmailLogin/EmailLogin";
import EmailLoginButton from "react-lib/apps/IsHealth/Common/EmailLogin/EmailLoginButton";
import EmailRegister from "react-lib/apps/IsHealth/Common/EmailLogin/EmailRegister";
import FacebookLoginButton from "react-lib/apps/IsHealth/Common/FacebookLogin/FBLoginButton";
import LineLoginManager from "react-lib/apps/IsHealth/Common/Line/LineLoginManager";
import LineLoginButton from "react-lib/apps/IsHealth/Common/Line/LoginButton";

import LandingUX from "./LandingUX";

import CONFIG from "config/config";

// Add window.FB type declaration at the top
declare global {
  interface Window {
    FB: any;
    fbAsyncInit: () => void;
  }
}

type LandingProps = {
  setProp: (key: string, value: any, callback?: () => void) => any;
  controller?: any;
  AppInitializeSequence: any;
  device_id?: string;
  loadingLogin?: boolean;
  openPassword?: boolean;
  languageUX: string;
  languageOptions: Record<string, any>[];
  // Callback
  facebookLogin?: (name: string) => void;
  onChangeLanguage?: (language: string) => void;
  onLoginFacebookSiteSuccess?: () => void;
  onLoginSubmit: () => void;
  onLoginSuccess?: (res: any) => void;
};

const IMAGES = {
  logo: "images/IHimage.png",
};

const SHOW_SOCIAL_LOGIN =
  CONFIG.PENTA_ACC_LINE_LOGIN || CONFIG.PENTA_ACC_FACEBOOK_LOGIN || CONFIG.PENTA_ACC_EMAIL_LOGIN;

const Landing = (props: LandingProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const [showEmailLogin, setShowEmailLogin] = useState(false);
  const [emailRegister, setEmailRegister] = useState<string | null>(null);

  const lineLoginManager = new LineLoginManager();

  // Moved from PlatformLogin
  const gotoLineLogin = () => {
    lineLoginManager.openLogin();
  };

  const handleResponseFacebook = async ({ data, deviceId, fbResponse }: any) => {
    const [response] = await props.controller?.postRegisterByTokenFacebook({
      accessToken: fbResponse.authResponse.accessToken,
      app: CONFIG.APP_NAME,
      device_id: deviceId,
    });

    if (response) {
      props.facebookLogin?.(data.name);
      props.onLoginSuccess?.({ ...response, type: "facebook" });
    }
  };

  if (emailRegister) {
    return (
      <EmailRegister
        email={emailRegister}
        onBack={() => {
          setEmailRegister(null);
        }}
      />
    );
  }

  if (showEmailLogin) {
    return (
      <EmailLogin
        onBack={() => {
          setShowEmailLogin(false);
        }}
        onRegister={(email: string) => {
          setEmailRegister(email);
        }}
      />
    );
  }

  return (
    <LandingUX
      imgStyle={{ maxWidth: SHOW_SOCIAL_LOGIN ? "900px" : "" }}
      loading={props.loadingLogin}
      loginSubmit={props.onLoginSubmit}
      logo={IMAGES.logo}
      password={props.AppInitializeSequence?.password || ""}
      selectedLanguage={props.languageUX.includes("th") ? "th" : "en"}
      typePassword={props.openPassword ? "" : "password"}
      username={props.AppInitializeSequence?.username || ""}
      languageUX={props.languageUX}
      languageOptions={props.languageOptions}
      onChangeSelectedLanguage={props.onChangeLanguage}
      changePassword={(e: any) => {
        props.setProp("AppInitializeSequence.password", e.target.value);
      }}
      changeUsername={(e: any) => {
        props.setProp("AppInitializeSequence.username", e.target.value);
      }}
      eye={
        props.openPassword ? (
          <Icon
            name="eye"
            link
            onClick={() => {
              props.setProp("openPassword", !props.openPassword);
            }}
          />
        ) : (
          <Icon
            name="eye slash"
            link
            onClick={() => {
              props.setProp("openPassword", !props.openPassword);
            }}
          />
        )
      }
      socialLogin={
        <>
          {SHOW_SOCIAL_LOGIN && (
            <Divider style={{ margin: "2rem 0" }} horizontal inverted>
              <div>{props.languageUX === "en" ? "Or sign in with" : "หรือเข้าสู่ระบบด้วย"}</div>
            </Divider>
          )}

          {CONFIG.PENTA_ACC_LINE_LOGIN && (
            <LineLoginButton
              style={{
                display: "flex",
                marginBottom: "20px",
                whiteSpace: "nowrap",
              }}
              lineLoginText={props.languageUX === "en" ? "Sign in with LINE" : "ล็อกอินด้วย LINE"}
              logoStyle={{ height: "40px", width: "40px" }}
              textStyle={{ margin: "auto" }}
              onClick={gotoLineLogin}
            />
          )}

          {CONFIG.PENTA_ACC_FACEBOOK_LOGIN && (
            <FacebookLoginButton
              style={{
                display: "flex",
                marginBottom: "20px",
                whiteSpace: "nowrap",
              }}
              appId="1782946359024414"
              logoStyle={{ height: "40px", padding: "5px" }}
              textStyle={{ margin: "auto" }}
              version="v23.0"
              onCallback={handleResponseFacebook}
              onLoading={setIsLoading}
              onSiteSuccess={props.onLoginFacebookSiteSuccess}
              fbLoginText={
                props.languageUX === "en" ? "Sign in with  Facebook" : "เข้าสู่ระบบด้วย Facebook"
              }
            />
          )}

          {CONFIG.PENTA_ACC_EMAIL_LOGIN && (
            <EmailLoginButton
              style={{
                display: "flex",
                marginBottom: "20px",
                whiteSpace: "nowrap",
              }}
              logoStyle={{ height: "40px", padding: "5px" }}
              textStyle={{ margin: "auto" }}
              onClick={() => {
                setShowEmailLogin(true);
              }}
              emailLoginText={
                props.languageUX === "en" ? "Sign in with email" : "ลงชื่อเข้าใช้งานด้วยอีเมล"
              }
            />
          )}
        </>
      }
    />
  );
};

Landing.displayName = "Landing";

export default React.memo(Landing);
